import React from "react";
import { Helmet } from "react-helmet";
import asusProducts from "../../../data/asus"; // create data file same structure as dell.js

export default function Asus() {
  const pageTitle ="Certified Refurbished ASUS Laptops in Bangalore | Credible Technologies";
  const pageDescription ="Buy certified refurbished ASUS laptops with warranty, tested for performance and reliability. Ideal for students, professionals, creators, and gamers in Bangalore.";

  return (
    <main className="w-full bg-white text-gray-900">

      {/* =================== SEO HEAD =================== */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link
          rel="canonical"
          href="https://www.credibletech.in/refurbished-laptops/asus/laptops"
        />

        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.credibletech.in/refurbished-laptops/asus/laptops"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
      </Helmet>

      {/* =====================================================
          ASUS BRAND DESCRIPTION WITH ICON
      ===================================================== */}
      <section className="relative bg-gradient-to-br from-black via-slate-900 to-black text-white overflow-hidden">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

        <div className="relative max-w-6xl mx-auto px-4 py-28 text-center">
          {/* ASUS Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-sm tracking-wide mb-6">
            ⚡ ASUS Refurbished Experts
          </div>

          {/* Brand Description */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-6">
            ASUS Laptops – Refurbished & Certified
          </h1>

          <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-4">
            ASUS is globally recognized for innovation, performance, and stylish
            laptop designs. From powerful Vivobook and ZenBook series to
            performance-driven TUF and ROG laptops, ASUS delivers cutting-edge
            computing for every need.
          </p>

          <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-4">
            Our refurbished ASUS laptops undergo strict quality checks and
            professional testing to ensure high performance, durability, and
            reliability. Refurbished ASUS devices offer premium features at
            significantly lower prices.
          </p>

          <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
            Whether you are a student, professional, creator, or gamer, our
            certified refurbished ASUS laptops provide excellent speed,
            multitasking power, long battery life, and complete peace of mind
            with warranty support.
          </p>
        </div>
      </section>

      {/* =====================================================
          ASUS PRODUCTS SECTION
      ===================================================== */}
      <section id="asus-products" className="max-w-7xl mx-auto px-4 py-20">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            Available ASUS Laptops
          </h2>
          <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
            Explore our certified refurbished ASUS laptops. Each device comes
            with verified specifications, warranty, and is ideal for work,
            creativity, and gaming.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 gap-10">
          {asusProducts.map((product) => (
            <article
              key={product.id}
              className="flex flex-col sm:flex-row border border-gray-200 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition bg-white"
            >
              {/* LEFT IMAGE */}
              <img
                src={product.image}
                alt={product.name}
                className="w-full sm:w-1/3 h-60 sm:h-auto object-cover"
              />

              {/* RIGHT CONTENT */}
              <div className="p-6 flex flex-col justify-between flex-grow bg-gradient-to-br from-gray-50 to-white">
                {/* Product Name */}
                <h3 className="text-2xl font-bold text-gray-900 mb-5">
                  {product.name}
                </h3>

                {/* Vertical Specs with colored badges */}
                <ul className="flex flex-col gap-3 mb-6">
                  {product.specs.map((spec, index) => {
                    const colors = [
                      "bg-red-100 text-red-800",
                      "bg-green-100 text-green-800",
                      "bg-blue-100 text-blue-800",
                      "bg-yellow-100 text-yellow-800",
                      "bg-purple-100 text-purple-800",
                      "bg-pink-100 text-pink-800",
                      "bg-indigo-100 text-indigo-800",
                      "bg-teal-100 text-teal-800",
                    ];
                    const colorClass = colors[index % colors.length];

                    return (
                      <li
                        key={index}
                        className={`${colorClass} font-semibold px-4 py-2 rounded-full shadow-md hover:scale-105 transition-transform`}
                      >
                        {spec}
                      </li>
                    );
                  })}
                </ul>

                {/* Buy Now Button */}
                <a
                  href={`https://wa.me/919538577199?text=${encodeURIComponent(product.whatsappText)}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-auto bg-black text-white py-3 px-8 rounded-xl text-sm font-semibold hover:bg-gray-800 transition self-start"
                >
                  Buy Now
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
